import {
  Breakpoints,
  ButtonAppearance,
  ButtonCustom,
  buttonPaddingGenerator,
} from '@vw-marketing/us-components';
import _ from 'lodash';
import React from 'react';
import {blockScrollAction} from '../../utils/general';
import { getButtonPadding } from './helpers';
import {
  StyledFilterButtonContainer,
  StyledFilterButtonWrapper,
  StyledFilterContentWrapper,
} from './styles';

interface FilterButtonProps {
  label: string;
  buttonLabel: string;
  isDisabled?: boolean;
  onHandleCtaAction?: () => void;
  filterSelectTracking?: () => void;
  children: React.ReactNode
}
type filterStatus = 'hidden' | 'open';
const FilterButton: React.FC<FilterButtonProps> = (props) => {
  const {label, onHandleCtaAction, filterSelectTracking, buttonLabel, isDisabled, children} = props;
  const labelKey = label.toLowerCase().replace(' ', '-');
  const [buttonStatus, setButtonStatus] =
    React.useState<filterStatus>('hidden');
  const filterContainerRef = React.useRef<HTMLDivElement | null>(null);

  const onHandleOpenClick = (event) => {
    if (isDisabled) return;
    event.nativeEvent.stopImmediatePropagation();
    setButtonStatus(buttonStatus === 'open' ? 'hidden' : 'open');
  };
  const onHandleApplyButtonClick = () => {
    setButtonStatus('hidden');
    onHandleCtaAction && onHandleCtaAction();
    filterSelectTracking && filterSelectTracking()
  };

  const onHandleLayerMouseDownEvent: React.MouseEventHandler<HTMLDivElement> = (
    event,
  ) => {
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    setButtonStatus('hidden');
  };

  /**
   * Hide dropdown option box when user is interacting with another component
   * @param event
   */
  const handleMouseDown: EventListenerOrEventListenerObject = (event) => {
    const isNotMobileViewport = window.matchMedia(
      `(min-width: ${Breakpoints.b960}px)`,
    ).matches;
    const container = (event.target as HTMLDivElement);
    if (filterContainerRef.current?.contains(container)) return;
    isNotMobileViewport && setButtonStatus('hidden');
  };


  React.useEffect(() => {
    blockScrollAction(buttonStatus === 'open');
    if (buttonStatus === 'open') {
      document.addEventListener('mousedown', handleMouseDown, false);
    } else {
      document.removeEventListener('mousedown', handleMouseDown, false);
    }
    return () => {
      blockScrollAction(false);
      document.removeEventListener('mousedown', handleMouseDown, false);
    };
  }, [buttonStatus]);

  // useClickOutsideContainer(filterContainerRef);

  return (
    <StyledFilterButtonContainer
      className={`filter-button_container ${labelKey}`}
      ref={filterContainerRef}
    >
      <div
        className={`active-layer ${buttonStatus}`}
        onMouseDown={onHandleLayerMouseDownEvent}
      />
      <StyledFilterButtonWrapper
        className={`filter-button-wrapper ${buttonStatus}`}
        isDisabled={isDisabled}
      >
        <ButtonCustom
          appearance={ButtonAppearance.Secondary}
          onClick={onHandleOpenClick}
          padding={getButtonPadding()}
        >
          {label}
        </ButtonCustom>
      </StyledFilterButtonWrapper>
      <StyledFilterContentWrapper
        className={`filter-content-wrapper ${buttonStatus}`}
      >
        {children}
        <div className="apply-button">
          <ButtonCustom
            onClick={onHandleApplyButtonClick}
            appearance={ButtonAppearance.Primary}
            padding={buttonPaddingGenerator(3, 19)}
          >
            {buttonLabel}
          </ButtonCustom>
        </div>
      </StyledFilterContentWrapper>
    </StyledFilterButtonContainer>
  );
};

export default FilterButton;
